import { useEffect, useState } from "react";
import _ from "lodash";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { API_URL, handleError, isManagerOver, downloadFile, isAccountant } from "src/Common/function";
import Button from "src/Components/Button";
import DownloadButton from "src/Components/DownloadButton";
import POService from "src/Services/API/po.service";
import UserService from "src/Services/API/user.service";
import Table from "./Components/PoTable";
import POFitlerView from "src/Components/filter/POFilterView";
import BranchBar from "src/Components/branchbar/BranchBar";
import PoTable from "./Components/PoTable";

function PO() {
  const user = UserService.getCurrentUser();
  // const keyword = useSelector((state) => state.Keyword.keyword);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);
  //filter & sort
  const [filterOpen, setFilterOpen] = useState(false);
  const [sort, setSort] = useState(null);

  const [isDownloading, setIsDownloading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const [branch, setBranch] = useState(-1);

  const keyword = searchParams.get("keyword") || "";

  useEffect(() => {
    const param = searchParams.get("branch");
    setBranch(param === null ? -1 : Number(param));
  }, [searchParams]);

  useEffect(() => {
    setPageNumber(0);
    getAllPurchaseOrder([], 0);

    if (criteria) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
    console.log("🚀 ~ PO ~ branch:", branch);
  }, [keyword, criteria, sort, branch]);

  const getAllPurchaseOrder = (previousOrderArray, pNumber) => {
    POService.getPurchaseOrder(user.id, keyword, pNumber, JSON.parse(criteria), sort, branch)
      .then((response) => {
        console.log("All PO Response: ", response.data);
        if (response.status == 200) {
          let temp = [...previousOrderArray, ...response.data.orders];
          setOrderArray(temp);
          if (temp.length >= response.data.totalCount) {
            setLoadMoreButtonShown(false);
          } else {
            setLoadMoreButtonShown(true);
          }
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        handleError(error);
      });
  };
  const handleLoadMore = () => {
    getAllPurchaseOrder(orderArray, pageNumber + 1);
    setPageNumber(pageNumber + 1);
  };

  // const savePO = (data) => {
  //   setIsCreateOpen(false);
  //   WOService.createWorkOrder(data)
  //     .then((response) => {
  //       console.log("response: ", response);
  //       if (response.status == 201) {
  //         toast("Work order created successfully");
  //         getAllPurchaseOrder();
  //       } else {
  //         toast("something went wrong!");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error: ", error);
  //       toast(error.response.data.message);
  //     });
  // };

  const downloadExcelFile = async () => {
    setIsDownloading(true);
    try {
      await POService.generateExcelFile(user.id, keyword, JSON.parse(criteria), sort, branch);
      await downloadFile(`${API_URL}/${user.company}/reports/${user.id}/POs_report.xlsx`, "POs_report.xlsx");
      setIsDownloading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const appendBranchParam = (query, value) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    url.set(query, value); // replaces or adds branch=0

    navigate(`${currentPath}?${url.toString()}`);
  };

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColor">
      {/* <div className="h-[60px] flex items-center relative mb-12 border-b-[1px] border-borderColor">
        <span className="font-OpenSansRegular font-[700] text-[24px] ml-5 text-titleColor ">Work Orders</span>
        <div className="absolute right-7 bottom-2 flex items-center gap-8">
          <SearchBox onKewordChanged={keywordChanged} />
        </div>
      </div> */}
      {/* <div className="relative"> */}
      {/* <CreateModal onSubmitClicked={savePO} shown={isCreateOpen} onCancelClicked={() => setIsCreateOpen(false)} /> */}
      <div className="px-5 py-2 border-b border-borderColor">
        {(isManagerOver() || isAccountant()) && <BranchBar />}
      </div>
      {branch !== 0 && (
        <div className="w-full flex items-center gap-8 justify-end px-5 py-2">
          <Button onClicked={() => setFilterOpen(!filterOpen)} title="Filter" isHighlighted={filterOpen} />
          {filterOpen && <DownloadButton isLoading={isDownloading} onClicked={downloadExcelFile} />}
        </div>
      )}
      {/* </div> */}
      <div className="px-5 p-5 flex-1 min-h-0 flex flex-col">
        {filterOpen && branch !== 0 && (
          <POFitlerView
            apply={(data) => {
              appendBranchParam("criteria", JSON.stringify(data));
            }}
            clear={() => localStorage.removeItem("PO_CRITERIA")}
          />
        )}
        <PoTable
          data={orderArray}
          keyword={keyword}
          branch={branch}
          loadMore={handleLoadMore}
          loadMoreButtonShown={loadMoreButtonShown}
          deleteSuccess={(index) => {
            let temp = _.cloneDeep(orderArray);
            temp.splice(index, 1);
            setOrderArray(temp);
          }}
          sort={(data) => setSort(data)}
        />
      </div>
    </div>
  );
}

export default PO;
